import React from "react";
import { Row, Col } from "antd";
import { ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";
import styles from "../DashBoard/DashBoard.module.scss";
import AddressTimeline from "./AddressTimeline";
import GMapsModal from "./GMapsModal";
import TripTimings from "./TripTimings";
import { useWindowSize } from "../../hooks/useWindowSize";

type Props = {
  trip: ITripDetails;
};

const TripDirections: React.FC<Props> = ({ trip }) => {
  const { width } = useWindowSize();
  return (
    <Row className={styles.tripAddressInstructions}>
      <Col xs={0} lg={3} />
      <Col lg={12} className={styles.addressMapBorderbox}>
        <Row>
          <Col xs={24} lg={12} className={styles.addressTimeline}>
            <AddressTimeline trip={trip} />
          </Col>
          <Col xs={24} lg={12}>
            <GMapsModal
              trip={trip}
              layoutWidth="auto"
              layoutHeight="186px"
              modalWidth={width > 992 ? "807px" : "345px"}
              modalHeight={width > 992 ? "501px" : "458px"}
            />
          </Col>
        </Row>
      </Col>
      <Col xs={24} lg={6} className={styles.tripTimings}>
        <TripTimings trip={trip} />
      </Col>
      <Col xs={0} lg={3} />
    </Row>
  );
};

export default TripDirections;
